import { Menu, MenuItem } from '@material-ui/core'
import { ReportProblemOutlined } from '@material-ui/icons'
import { useState } from 'react'

import AlertDialog from '@/components/alert-dialog'
import { useDeleteHerbicideTreatment } from '@/hooks/mutations/use-delete-herbicide-treatment'
import { HerbicideTreatment } from '@/services/get-herbicide-treatments'

import { useStyles } from './styles'

export interface HerbicideTreatmentMenuProps {
  menu: HTMLElement | null
  selectedHerbicideTreatment: HerbicideTreatment | null
  onCloseMenu: () => void
  clearSelectedHerbicideTreatment: () => void
  onEditHerbicideTreatment: () => void
}

export function HerbicideTreatmentMenu({
  menu,
  selectedHerbicideTreatment,
  onCloseMenu,
  clearSelectedHerbicideTreatment,
  onEditHerbicideTreatment,
}: HerbicideTreatmentMenuProps) {
  const classes = useStyles()

  const [
    showRemoveHerbicideTreatmentDialog,
    setShowRemoveHerbicideTreatmentDialog,
  ] = useState(false)

  const { mutate, isLoading } = useDeleteHerbicideTreatment()

  const handleRemoveHerbicideTreatmentDialog = () => {
    setShowRemoveHerbicideTreatmentDialog(true)
    onCloseMenu()
  }

  const handleCloseMenu = () => {
    onCloseMenu()
    clearSelectedHerbicideTreatment()
  }

  return (
    <>
      <Menu
        anchorEl={menu}
        open={Boolean(menu)}
        onClose={handleCloseMenu}
        classes={{ paper: classes.menu }}
        elevation={3}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={onEditHerbicideTreatment}>Editar</MenuItem>
        <MenuItem onClick={handleRemoveHerbicideTreatmentDialog}>
          Excluir
        </MenuItem>
      </Menu>

      <AlertDialog
        open={showRemoveHerbicideTreatmentDialog}
        dialogActionsClassname={classes.dialogActions}
        icon={<ReportProblemOutlined />}
        title='Excluir tratamento'
        subtitle='Tem certeza que gostaria de excluir esse tratamento?'
        variant='error'
        cancel='Cancelar'
        confirm='Sim, excluir'
        items={['Essa ação não poderá ser desfeita']}
        handleCancel={() => {
          setShowRemoveHerbicideTreatmentDialog(false)
          clearSelectedHerbicideTreatment()
        }}
        loading={isLoading}
        handleConfirm={() => {
          mutate(selectedHerbicideTreatment?.id!, {
            onSuccess: () => {
              setShowRemoveHerbicideTreatmentDialog(false)
              clearSelectedHerbicideTreatment()
            },
          })
        }}
      />
    </>
  )
}
